module Meevo.Plugins.Product {
    export class PrintModalController {

        static $inject = [ //update here names defined in modal options
            'product',
            'callback',
            '$translate',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService'
        ];

        protected variants: Meevo.Model.Variant[];
        public isAllSelected: boolean = true;
        //public countNumberOfLabels: boolean;
        

        constructor( //parameters here
            protected product: Model.Product,
            private callback: Function,
            private $translate: angular.translate.ITranslateService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
            //this.product.variants.forEach(pv => pv.onHand = 3); // testing only
            this.product.variants.forEach(pv => pv.numberOfLabels = pv.onHand);
        }
        close() {
            this.modalService.hide();
        }
        cancel() {
            this.modalService.hide();
        }
        continue() { 
            var items: Meevo.Model.Variant[] = this.product.variants.filter(v => v.numberOfLabels > 0 && v.selected );
            /* populate items with variants having count > 0 */
            //number greater than 0 and selected
            this.callback(items); 
            this.modalService.hide(); //hide after click, land on DP0005 page
        }

        selectAll(newValue: boolean) {
            this.isAllSelected = newValue;
            this.product.variants.forEach(item => {
                item.selected = this.isAllSelected;
            });
            //return newValue
        }

        checkSelectedItem(item: Meevo.Model.Variant) {
            this.isAllSelected = this.product.variants.every((item: any) => item.selected);
            if (item.selected) {
                item.numberOfLabels = item.onHand;
            } else {
                item.numberOfLabels = 0;
            }
        }
         
        canPrint(): boolean {
            var allow: boolean = false;
            for (var ndx = 0; ndx < this.product.variants.length; ndx++) {
                var obj: Meevo.Model.Variant = this.product.variants[ndx];
                if (obj.selected && obj.numberOfLabels > 0) {
                    allow = true;
                    break;
                } 
            }
            return allow;
        }


        
    }
    angular.module("meevo.plugins.product")
        .controller("meevo.plugins.product.PrintModalController", PrintModalController);
}